module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[22]143.85b1b2e.woff2";